import request from '../request'

/**
 * 竣工报告相关接口
 * 从 cosystem-portal 同步过来的入口，本仓暂未启用对应后端，使用前请核对 URL。
 */

export function addCompletionReport(data) {
    return request({
        url: '/project-service/cosys/completion/report/add',
        method: 'POST',
        data
    })
}

export function deleteCompletionReport(id) {
    return request({
        url: `/project-service/cosys/completion/report/del/${id}`,
        method: 'GET'
    })
}

export function fetchCompletionReportDetail(id) {
    return request({
        url: `/project-service/cosys/completion/report/detail/${id}`,
        method: 'GET'
    })
}

export function fetchCompletionReportList(params) {
    return request({
        url: '/project-service/cosys/completion/report/list',
        method: 'GET',
        params
    })
}

export function updateCompletionReport(data) {
    return request({
        url: '/project-service/cosys/completion/report/update',
        method: 'POST',
        data
    })
}

export function resubmitCompletionReport(data) {
    return request({
        url: '/project-service/cosys/completion/report/resubmit',
        method: 'POST',
        data
    })
}
